/** S3 static にアップロードしたファイル */
export const s3StaticPath = 'https://proffit.s3-ap-northeast-1.amazonaws.com/upload/static';
/** デフォルトの OGP 画像 */
export const PROFFIT_DEFAULT_OGP = 'https://proffit.s3-ap-northeast-1.amazonaws.com/upload/static/ogp.png';
/**
 * 共通ページ見出し
 */
export const PROFFIT_BG_PAGE_HEAD = {
    pc: {
        base: `${s3StaticPath}/lp/components/bg_page_head_consultation_pc.png`,
        webp: `${s3StaticPath}/lp/components/bg_page_head_consultation_pc.webp`,
    },
    sp: {
        base: `${s3StaticPath}/lp/components/bg_page_head_consultation_sp.png`,
        webp: `${s3StaticPath}/lp/components/bg_page_head_consultation_sp.webp`,
    },
};
/**
 * 共通ページ見出し（ビル用）
 */
export const PROFFIT_BG_PAGE_BUILDING_HEAD = {
    pc: {
        base: `${s3StaticPath}/ui/head/bg_page_head_building_pc.png`,
        webp: `${s3StaticPath}/ui/head/bg_page_head_building_pc.webp`,
    },
    sp: {
        base: `${s3StaticPath}/ui/head/bg_page_head_building_sp.png`,
        webp: `${s3StaticPath}/ui/head/bg_page_head_building_sp.webp`,
    },
};
/**
 * TOP
 */
export const PROFFIT_TOP_MAIN_IMAGE = {
    pc: {
        base: `${s3StaticPath}/lp/top/top_main_image_pc_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_main_image_pc_v2.webp`,
    },
    sp: {
        base: `${s3StaticPath}/lp/top/top_main_image_sp_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_main_image_sp_v2.webp`,
    },
};
export const PROFFIT_TOP_BG_GRADATION = {
    pc: {
        base: `${s3StaticPath}/lp/top/top_bg_gradation_pc_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_bg_gradation_pc_v2.webp`,
    },
    sp: {
        base: `${s3StaticPath}/lp/top/top_bg_gradation_sp_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_bg_gradation_sp_v2.webp`,
    },
};
/**
 * TOP（コンサルタントTOP）: 数字で見るPROFFIT
 */
export const PROFFIT_TOP_NUMBER_ICON_BUDGET = {
    base: `${s3StaticPath}/lp/top/top_icon_number_budget_v2.svg`,
};
export const PROFFIT_TOP_NUMBER_ICON_DETERMINING_RATE = {
    base: `${s3StaticPath}/lp/top/top_icon_number_determining_rate_v2.svg`,
};
export const PROFFIT_TOP_NUMBER_ICON_PROPOSAL_NUMBER = {
    base: `${s3StaticPath}/lp/top/top_icon_number_proposal_number_v2.svg`,
};
export const PROFFIT_TOP_NUMBER_ICON_COMPANY = {
    base: `${s3StaticPath}/lp/for_consultant/top_icon_number_company_2.svg`,
};
export const PROFFIT_TOP_NUMBER_ICON_USER_COUNT = {
    base: `${s3StaticPath}/lp/for_consultant/top_icon_number_user_count_v2.svg`,
};
/**
 * TOP: ご利用企業
 */
export const PROFFIT_TOP_COMPANY_LOGO_ASTELLAS = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_astellas.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_astellas.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_CHUGAISEIYAKU = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_chugaiseiyaku.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_chugaiseiyaku.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_DAIICHISANKYO = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_daiichisankyo.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_daiichisankyo.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_DOCOMO = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_docomo.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_docomo.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_FAMILYMART = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_familymart.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_familymart.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_FUJIFILM = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_fujifilm.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_fujifilm.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_IHI = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_ihi.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_ihi.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_JT = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_jt.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_jt.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_KANEBO = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_kanebo.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_kanebo.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_KAO = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_kao.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_kao.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_MARUBENI = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_marubeni.webp`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_marubeni.png`,
};
export const PROFFIT_TOP_COMPANY_LOGO_MARUHAN = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_maruhan.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_maruhan.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_MEIJI = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_meiji.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_meiji.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_MITSUBISHI = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_mitsubishi.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_mitsubishi.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_MITSUIBUSSAN = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_mitsui_bussan.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_mitsui_bussan.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_NISSAN = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_nissan.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_nissan.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_NTTCOM = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_nttcom.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_nttcom.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_PANASONIC = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_panasonic.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_panasonic.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_RECRUIT = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_recruit.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_recruit.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_RAKUTEN = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_rekuten.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_rekuten.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_SONY = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_sony.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_sony.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_SUMITOMOSYOUZI = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_sumitomosyouzi.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_sumitomosyouzi.webp`,
};
export const PROFFIT_TOP_COMPANY_LOGO_TOYOTA = {
    base: `${s3StaticPath}/lp/top/use_company_logo/top_logo_toyota.png`,
    webp: `${s3StaticPath}/lp/top/use_company_logo/top_logo_toyota.webp`,
};
/**
 * TOP: PROFFITのこだわり イラスト画像
 */
export const PROFFIT_TOP_ILLUSTRATION_ADVISER = {
    base: `${s3StaticPath}/lp/top/top_illustration_adviser_v2.svg`,
};
export const PROFFIT_TOP_ILLUSTRATION_CONSULTANT = {
    base: `${s3StaticPath}/lp/top/top_illustration_consultant_v2.svg`,
};
export const PROFFIT_TOP_ILLUSTRATION_PROPOSAL = {
    base: `${s3StaticPath}/lp/top/top_illustration_proposal_v2.svg`,
};
/**
 * TOP: サービス関連の見出し
 */
export const PROFFIT_TOP_BG_SERVICE_HEAD = {
    pc: {
        base: `${s3StaticPath}/lp/top/top_bg_service_head_pc_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_bg_service_head_pc_v2.webp`,
    },
    sp: {
        base: `${s3StaticPath}/lp/top/top_bg_service_head_sp_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_bg_service_head_sp_v2.webp`,
    },
};
export const PROFFIT_TOP_SERVICE_HEAD_LOGO = {
    base: `${s3StaticPath}/lp/top/top_outline_text_logo.png`,
    webp: `${s3StaticPath}/lp/top/top_outline_text_logo.webp`,
};
/**
 * TOP:サービスの流れ
 */
export const PROFFIT_TOP_SERVICE_FLOW_STEP_ONE = {
    base: `${s3StaticPath}/lp/top/top_service_flow_step_one_v2.png`,
    webp: `${s3StaticPath}/lp/top/top_service_flow_step_one_v2.webp`,
};
export const PROFFIT_TOP_SERVICE_FLOW_STEP_TWO = {
    base: `${s3StaticPath}/lp/top/top_service_flow_step_two_v2.png`,
    webp: `${s3StaticPath}/lp/top/top_service_flow_step_two_v2.webp`,
};
export const PROFFIT_TOP_SERVICE_FLOW_STEP_THREE = {
    base: `${s3StaticPath}/lp/top/top_service_flow_step_three_v2.png`,
    webp: `${s3StaticPath}/lp/top/top_service_flow_step_three_v2.webp`,
};
/**
 * TOP: サービスの流れ（資料画像）
 */
export const PROFFIT_TOP_SERVICE_FLOW_ONE = {
    one: {
        base: `${s3StaticPath}/lp/top/top_service_flow_01-01.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_01-01.webp`,
    },
    three: {
        base: `${s3StaticPath}/lp/top/top_service_flow_01-03.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_01-03.webp`,
    },
    two: {
        base: `${s3StaticPath}/lp/top/top_service_flow_01-02.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_01-02.webp`,
    },
};
export const PROFFIT_TOP_SERVICE_FLOW_TWO = {
    one: {
        base: `${s3StaticPath}/lp/top/top_service_flow_02-01.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_02-01.webp`,
    },
    three: {
        base: `${s3StaticPath}/lp/top/top_service_flow_02-03.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_02-03.webp`,
    },
    two: {
        base: `${s3StaticPath}/lp/top/top_service_flow_02-02.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_02-02.webp`,
    },
};
export const PROFFIT_TOP_SERVICE_FLOW_THREE = {
    one: {
        base: `${s3StaticPath}/lp/top/top_service_flow_03-01.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_03-01.webp`,
    },
    three: {
        base: `${s3StaticPath}/lp/top/top_service_flow_03-03.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_03-03.webp`,
    },
    two: {
        base: `${s3StaticPath}/lp/top/top_service_flow_03-02.png`,
        webp: `${s3StaticPath}/lp/top/top_service_flow_03-02.webp`,
    },
};
/**
 * コンサル選びのご支援事例
 */
export const PROFFIT_TOP_SUPPORT_CASE = {
    pc: `${s3StaticPath}/lp/top/top-hotline-banner_pc.webp`,
    sp: `${s3StaticPath}/lp/top/top-hotline-banner_sp.webp`,
};
/**
 * TOP: ユーザーの声
 */
export const PROFFIT_TOP_BG_USER_VOICE = {
    pc: {
        base: `${s3StaticPath}/lp/top/top_bg_user_voice_pc_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_bg_user_voice_pc_v2.webp`,
    },
    sp: {
        base: `${s3StaticPath}/lp/top/top_bg_user_voice_sp_v2.png`,
        webp: `${s3StaticPath}/lp/top/top_bg_user_voice_sp_v2.webp`,
    },
};
/**
 * ユーザーの声: 顔写真
 */
export const PROFFIT_TOP_USER_VOICE_IMAGE_KAO = {
    base: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_kao.png`,
    webp: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_kao.webp`,
};
export const PROFFIT_TOP_USER_VOICE_IMAGE_NSG = {
    base: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_nsg.png`,
    webp: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_nsg.webp`,
};
export const PROFFIT_TOP_USER_VOICE_IMAGE_TSNETWORK = {
    base: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_tsnetwork.png`,
    webp: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_tsnetwork.webp`,
};
export const PROFFIT_TOP_USER_VOICE_IMAGE_YOKOGAWA = {
    base: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_yokogawa.png`,
    webp: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_yokogawa.webp`,
};
export const PROFFIT_TOP_USER_VOICE_IMAGE_CAREER_LINK = {
    base: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_career_link.png`,
    webp: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_career_link.webp`,
};
export const PROFFIT_TOP_USER_VOICE_IMAGE_KOKUYO = {
    base: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_kokuyo.png`,
    webp: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_kokuyo.webp`,
};
export const PROFFIT_TOP_USER_VOICE_IMAGE_PANASONIC = {
    base: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_panasonic.png`,
    webp: `${s3StaticPath}/lp/top/user_voice/top_user_voice_image_panasonic.webp`,
};
/**
 * TOP: ご利用料金
 */
export const PROFFIT_TOP_USAGE_FEE = {
    base: `${s3StaticPath}/lp/top/top_usage_fee_v2.svg`,
};
/**
 * お問い合わせ: イラスト画像
 */
export const PROFFIT_CONTACT_ILLUSTRATION_CASUAL = {
    base: `${s3StaticPath}/contact/contact_illustration_casual_v2.svg`,
};
export const PROFFIT_CONTACT_ILLUSTRATION_CONSULTANT = {
    base: `${s3StaticPath}/contact/contact_illustration_consultant_v2.svg`,
};
export const PROFFIT_CONTACT_ILLUSTRATION_OTHER = {
    base: `${s3StaticPath}/contact/contact_illustration_other_v2.svg`,
};
/**
 * コンサルタント向けTOP: イラスト画像
 */
export const PROFFIT_TOP_ILLUSTRATION_ADVISORY_SUPPORT = {
    base: `${s3StaticPath}/lp/for_consultant/top_illustration_advisory_support_v2.svg`,
};
export const PROFFIT_TOP_ILLUSTRATION_GROWING_SUPPORT = {
    base: `${s3StaticPath}/lp/for_consultant/top_illustration_growing_support_v2.svg`,
};
export const PROFFIT_TOP_ILLUSTRATION_PROPOSAL_SUPPORT = {
    base: `${s3StaticPath}/lp/for_consultant/top_illustration_proposal_support_v2.svg`,
};
export const PROFFIT_TOP_ILLUSTRATION_RECRUITMENT_SUPPORT = {
    base: `${s3StaticPath}/lp/for_consultant/top_illustration_recruitment_support_v2.svg`,
};
/**
 * 会社概要: CEOポートレート
 */
export const PROFFIT_TOP_CEO_PORTRAIT = {
    base: `${s3StaticPath}/company/portrait-sekine.png`,
    webp: `${s3StaticPath}/company/portrait-sekine.webp`,
};
/**
 * HOTLINE LP
 */
export const HOTLINE_LP_MEETING = `${s3StaticPath}/lp/hotline/img_meeting.webp`;
export const HOTLINE_LP_MEETING_WOMEN = `${s3StaticPath}/lp/hotline/img_meeting_women.webp`;
/**
 * HOTLINE LP: MV
 */
export const HOTLINE_LP_MV = `${s3StaticPath}/lp/hotline/img_mv.webp`;
/**
 * HOTLINE LP: CONCEPT
 */
export const HOTLINE_LP_CONCEPT = `${s3StaticPath}/lp/hotline/img_concept.webp`;
/**
 * HOTLINE LP: CONCEPT背景
 */
export const HOTLINE_LP_CONCEPT_BG = `${s3StaticPath}/lp/hotline/bg_parts_2.webp`;
/**
 * HOTLINE LP: CONCEPT
 */
export const HOTLINE_LP_LOGO = `${s3StaticPath}/lp/hotline/img_logo.webp`;
/**
 * HOTLINE LP: BACKGROUND
 */
export const HOTLINE_LP_BACKGROUND_1 = `${s3StaticPath}/lp/hotline/bg_parts_1.webp`;
export const HOTLINE_LP_BACKGROUND_2 = `${s3StaticPath}/lp/hotline/bg_parts_2.webp`;
export const HOTLINE_LP_BACKGROUND_3 = `${s3StaticPath}/lp/hotline/bg_parts_3.webp`;
export const HOTLINE_LP_BACKGROUND_4 = `${s3StaticPath}/lp/hotline/bg_parts_4.webp`;
export const HOTLINE_LP_BACKGROUND_5 = `${s3StaticPath}/lp/hotline/bg_parts_5.webp`;
export const HOTLINE_LP_BACKGROUND_6 = `${s3StaticPath}/lp/hotline/bg_parts_6.webp`;
export const HOTLINE_LP_BACKGROUND_7 = `${s3StaticPath}/lp/hotline/bg_parts_7.webp`;
export const HOTLINE_LP_BACKGROUND_8 = `${s3StaticPath}/lp/hotline/bg_parts_8.webp`;
/**
 * コンサルタント向け コラム掲載説明ファイル
 */
export const CONSULTANT_COLUMN_GUIDE = `${s3StaticPath}/PROFFIT%E3%82%B3%E3%83%A9%E3%83%A0%E6%8E%B2%E8%BC%89%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB%EF%BC%88%E6%8E%B2%E8%BC%89%E3%83%95%E3%82%A9%E3%83%BC%E3%83%9E%E3%83%83%E3%83%88%EF%BC%89+.docx`;
